import { webKnots } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { w34WebVerticalParts } from './parts/w34WebVerticalParts'

export const w34Web = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // 横下パーツ
  await middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1, printLeatherTypeValue)
  // 縦パーツ
  await w34WebVerticalParts(ctx, webColor2 || webColor, laceColor, stitchColor, printLeatherTypeValue)
  webKnots(ctx, laceColor, -90, 100) // クロス中央の結び目
  webKnots(ctx, laceColor, -110, 120) // 捕球面上のウェブ結び目
}
